import { createGlobalStyle } from 'styled-components';

// Importando estilo de componentes
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Sarabun:300,400,700&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: Sarabun,sans-serif;

    &::-webkit-scrollbar-track {
      background-color: #2a3142 !important;
    }

    &::-webkit-scrollbar {
      width: 6px !important;
      background: #eee !important;
    }
    &::-webkit-scrollbar-thumb {
      background: #eee !important;
}
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    background: #252735;
    overflow-x: hidden;
  }

  body {
    -webkit-font-smoothing: antialiased !important;
  }

  body, input, button {
    font: 14px 'Sarabum', sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }
`;
